import CouponAppliedBanner from './CouponAppliedBanner'

export default CouponAppliedBanner
